import React, {useState} from 'react'
import {motion} from 'framer-motion'
import {ReactComponent as EmptyStar} from '../../common/assets/star-icon/empty-star-icon.svg'
import {ReactComponent as FullStar} from '../../common/assets/star-icon/full-star-icon.svg'
import {ReactComponent as HalfStar} from '../../common/assets/star-icon/half-star-icon.svg'
import {Block} from 'jsxstyle'

interface StarRatingProps {
  rating: number
  width?: number
  height?: number
  editable?: boolean
  onChange?: (newRating: number) => void
}

const StarRating: React.FC<StarRatingProps> = ({rating, width = 118, height = 18, editable = false, onChange}) => {
  const [hoveredRating, setHoveredRating] = useState<number | null>(null)

  const fullStars = Math.floor(rating)
  const hasHalfStar = rating % 1 > 0

  if (!editable) {
    return (
      <Block display="flex">
        {[...Array(5)].map((_, index) =>
          index < fullStars ? (
            <FullStar key={index} width={width / 5} height={height} />
          ) : hasHalfStar && index === fullStars ? (
            <HalfStar key={index} width={width / 5} height={height} />
          ) : (
            <EmptyStar key={index} width={width / 5} height={height} color="#FFE9C0" />
          )
        )}
      </Block>
    )
  }

  return (
    <Block props={{onMouseLeave: () => setHoveredRating(null)}} display="flex" cursor="pointer">
      {[1, 2, 3, 4, 5].map((starValue) => (
        <motion.div
          key={starValue}
          onMouseEnter={() => setHoveredRating(starValue)}
          onClick={() => onChange && onChange(starValue)}
          whileHover={{scale: 1.2}}
          transition={{duration: 0.2}}
        >
          {starValue <= (hoveredRating ?? rating) ? (
            <FullStar width={width / 5} height={height} />
          ) : (
            <EmptyStar width={width / 5} height={height} color="#BBDAFF" />
          )}
        </motion.div>
      ))}
    </Block>
  )
}

export default StarRating
